// extracted by mini-css-extract-plugin
export default {"main_css_us":"Input_main_css_us__e5oYb","main_css_jp":"Input_main_css_jp__UcWES"};